/**
 * Party Rate rows (CargoBooks): Change Amount "No" locks and clears the row's charge boxes (St Charge, Thela Charge,
 * Change Amt Applicable, Thela For); "Yes" opens them.
 *
 *   <select data-kit-charge-switch><option value="true">Yes</option><option value="false">No</option></select>
 *   <input data-charge>   in the same row
 *
 * Listens on the document, so rows added later work too.
 */
document.addEventListener("change", (event) => {
  const sel = event.target;
  if (!(sel instanceof HTMLSelectElement) || !sel.matches("[data-kit-charge-switch]")) return;
  const on = sel.value === "true";
  sel.closest("tr")?.querySelectorAll<HTMLInputElement | HTMLSelectElement>("[data-charge]").forEach((box) => {
    box.disabled = !on;
    if (on) return;
    if (box instanceof HTMLInputElement && box.type === "checkbox") box.checked = false;
    else box.value = "";
  });
});
